/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseResponseEntity } from '../models/BaseResponseEntity';
import type { CreateHiloAccountEntity } from '../models/CreateHiloAccountEntity';
import type { CreateHiloEinvoiceAccountDto } from '../models/CreateHiloEinvoiceAccountDto';
import type { DeleteHiloAccountEntity } from '../models/DeleteHiloAccountEntity';
import type { HealthCheckHiloEinvoiceAccountDto } from '../models/HealthCheckHiloEinvoiceAccountDto';
import type { ListHiloAccountsEntity } from '../models/ListHiloAccountsEntity';
import type { UpdateHiloAccountEntity } from '../models/UpdateHiloAccountEntity';
import type { UpdateHiloEinvoiceAccountDto } from '../models/UpdateHiloEinvoiceAccountDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EInvoiceAccountsService {
  /**
   * Nhập tài khoản HILO mới
   * @param requestBody Thông tin tài khoản HILO cần nhập
   * @returns CreateHiloAccountEntity
   * @throws ApiError
   */
  public static einvoiceAccountControllerCreateHiloAccount(
    requestBody: CreateHiloEinvoiceAccountDto,
  ): CancelablePromise<CreateHiloAccountEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/einvoice/accounts',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Danh sách tài khoản HILO
   * @param page Page number
   * @param limit Items per page
   * @returns ListHiloAccountsEntity
   * @throws ApiError
   */
  public static einvoiceAccountControllerListHiloAccounts(
    page?: string,
    limit?: string,
  ): CancelablePromise<ListHiloAccountsEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/einvoice/accounts',
      query: {
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * Kiểm tra kết nối tài khoản HILO
   * @param requestBody Thông tin tài khoản HILO cần kiểm tra kết nối
   * @returns BaseResponseEntity
   * @throws ApiError
   */
  public static einvoiceAccountControllerHealthCheckHiloAccount(
    requestBody: HealthCheckHiloEinvoiceAccountDto,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/einvoice/accounts/health-check',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Cập nhật tài khoản HILO
   * @param accountId
   * @param requestBody
   * @returns UpdateHiloAccountEntity
   * @throws ApiError
   */
  public static einvoiceAccountControllerUpdateHiloAccount(
    accountId: string,
    requestBody: UpdateHiloEinvoiceAccountDto,
  ): CancelablePromise<UpdateHiloAccountEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/einvoice/accounts/{accountId}',
      path: {
        accountId: accountId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Xoá tài khoản HILO
   * @param accountId
   * @returns DeleteHiloAccountEntity
   * @throws ApiError
   */
  public static einvoiceAccountControllerDeleteHiloAccount(
    accountId: string,
  ): CancelablePromise<DeleteHiloAccountEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/einvoice/accounts/{accountId}',
      path: {
        accountId: accountId,
      },
    });
  }
}
